import { MasterDialog } from "#common/Dialog/Dialog"
import InputText from "#common/input/InputText"
import { EvaluacionType } from "#competence/constants"
import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import { UseContextsQuestion } from "#competence/contexts/ContextsQuestion"
// import { UseContextsCompetence } from "#competence/contexts/ContextsSelect"
import { QuestionPost, QuestionPut } from "#competence/services/Api"
import { useApiSend } from "#hooks/useApiSend"
import { Stack } from "@mui/material"
import { Fragment, useCallback, useEffect, useMemo, useState } from "react"

const dataBase = { question: "", auxiliary: "", type: "" }

export default function CompetenceQuestionForm() {
	const { refresh, setOpen, open, question, setQuestion } = UseContextsQuestion()
	const { competence } = UseContextsCompetence()
	const [form, setForm] = useState({ ...dataBase, type: question?.type })
	const [disabled, setDisabled] = useState(false)
	const [disabledCancelar, setDisabledCancelar] = useState(false)
	const isEdit = useMemo(() => !!question?.id, [question?.id])
	const isEntrevista = useMemo(
		() => EvaluacionType.ENTREVISTA === question?.type,
		[question?.type]
	)
	useEffect(() => {
		let data = dataBase
		if (isEdit) {
			data = { ...question }
		} else if (question?.type) data = { ...dataBase, type: question.type }

		setForm(data)
	}, [isEdit, question, question?.type])

	const closeDialog = useCallback(() => {
		setQuestion(null)
		setForm(dataBase)
		setOpen(false)
	}, [setOpen, setQuestion])

	const success = () => {
		refresh()
		closeDialog()
	}

	const end = () => {
		setDisabled(false)
		setDisabledCancelar(false)
	}

	const { fetch: fetchPost } = useApiSend(QuestionPost, { success, end })
	const { fetch: fetchPut } = useApiSend(QuestionPut, { success, end })

	useEffect(() => {
		if (form.question.trim() === "") {
			setDisabled(true)
			return
		}
		if (isEntrevista && form.auxiliary.trim() === "") {
			setDisabled(true)
			return
		}
		setDisabled(false)
	}, [form.auxiliary, form.question, isEntrevista])

	const fetch = useCallback(() => {
		const data = { ...form }
		if (!isEntrevista) data.auxiliary = null
		if (isEdit) {
			fetchPut(question.id, data)
		} else {
			fetchPost(competence.id, data)
		}
	}, [competence.id, fetchPost, fetchPut, form, isEdit, isEntrevista, question?.id])

	const buttons = useMemo(() => {
		return [
			{
				label: "Cancelar",
				onClick: closeDialog,
				disabled: disabledCancelar,
			},
			{
				label: "Guardar",
				onClick: () => {
					setDisabled(true)
					setDisabledCancelar(true)
					fetch()
				},
				disabled,
			},
		]
	}, [closeDialog, disabled, disabledCancelar, fetch])

	return (
		<Fragment>
			<MasterDialog
				{...{
					open: open === "form",
					setOpen,
					title: `Agregar Pregunta ${
						question?.type === 1 ? "Entrevista" : " Evaluación"
					}`,
					buttons,
					closeDialog,
				}}
				maxWidth="sm"
			>
				<Stack spacing={2} sx={{ width: "100%" }}>
					<InputText
						label="Pregunta"
						value={form.question}
						setValue={(data) => setForm({ ...form, question: data })}
						multiline
						minRows={1}
						maxRows={3}
					/>
					{isEntrevista && (
						<InputText
							label="Preguntas auxiliares"
							multiline={true}
							rows={4}
							value={form.auxiliary}
							setValue={(data) => setForm({ ...form, auxiliary: data })}
						/>
					)}
				</Stack>
			</MasterDialog>
		</Fragment>
	)
}
